import React from 'react';
import { IconButton, SxProps, Theme } from '@mui/material';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExitSharp';
import FullscreenIcon from '@mui/icons-material/FullscreenSharp';
import useIsMobile from 'hooks/useIsMobile';
import { SGTooltip } from 'components/core';
import { useStandardDashboardFullscreen } from 'layouts/ResizableDashboardLayout';
import { DashboardLayoutType } from 'types/shared';
import { useVerticalDashboardFullscreen } from 'layouts/VerticalDashboardLayout';

interface PanelFullscreenButtonProps {
  panelType: 'main' | 'bottom';
  sx?: SxProps<Theme>;
  showTooltip?: boolean;
  layoutType?: DashboardLayoutType;
}

const PanelFullscreenButton: React.FC<PanelFullscreenButtonProps> = ({
  panelType,
  sx,
  showTooltip = true,
  layoutType = DashboardLayoutType.RESIZABLE_STANDARD,
}) => {
  const isMobile = useIsMobile();

  const useFullscreenHook =
    layoutType === DashboardLayoutType.RESIZABLE_STANDARD
      ? useStandardDashboardFullscreen
      : useVerticalDashboardFullscreen;

  const {
    isMainFullscreen,
    isBottomFullscreen,
    toggleMainFullscreen,
    toggleBottomFullscreen,
  } = useFullscreenHook();

  const isFullscreen =
    panelType === 'main' ? isMainFullscreen : isBottomFullscreen;
  const toggleFullscreen =
    panelType === 'main' ? toggleMainFullscreen : toggleBottomFullscreen;

  if (isMobile) {
    return null;
  }

  const button = (
    <IconButton onClick={toggleFullscreen} size="small" color="primary" sx={sx}>
      {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
    </IconButton>
  );

  if (!showTooltip) {
    return button;
  }

  return (
    <SGTooltip title={isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}>
      {button}
    </SGTooltip>
  );
};

export default PanelFullscreenButton;
